export default __webpack_public_path__ + "static/media/emptyListingMigration.1a6471d7.png";